var version = {
    "name":      "dativery",
    "buildDateCode": "20251120-171621",
    "buildDate": "Thu Nov 20 2025 17:16:21 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251120-171621",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;